import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetRequestForInformationDetailsAsync,
  IRequestForInformation,
} from "../../api/RequestForInformation";
import { RootState } from "../store";

export interface RequestForInformationState {
  fetchStatus: string;
  requestForInformation?: IRequestForInformation;
}

const initialState: RequestForInformationState = {
  fetchStatus: "Loading...",
  requestForInformation: undefined,
};

export const loadRequestForInformationAsync = createAsyncThunk(
  "requestForInformation/load",
  async (reuestForInformationId: string) => {
    const response = await GetRequestForInformationDetailsAsync(
      reuestForInformationId
    );
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const requestForInformationSlice = createSlice({
  name: "requestForInformation",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadRequestForInformationAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadRequestForInformationAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.requestForInformation = action.payload;
      });
  },
});

export const selectRequestForInformation = (state: RootState) =>
  state.requestForInformation;

export default requestForInformationSlice.reducer;
